module.exports = __webpack_public_path__ + "img/canada-leukaemia-female.e5aa09de.png";